import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SelfcareExtendedOtpButtonBlockData from '../../../Models/Content/SelfcareExtendedOtpButtonBlockData';
import SelfcareExtendedOtpButton from './SelfcareExtendedOtpButton';

export default class SelfcareExtendedOtpButtonBlock extends EpiComponent<SelfcareExtendedOtpButtonBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <SelfcareExtendedOtpButton context={this.getContext()} iContent={this.props.data} />;
  }
}
